import banner1 from '../../assets/images/banner1.jpg'
import banner2 from '../../assets/images/banner2.jpg'
import banner3 from '../../assets/images/banner3.jpg'
import banner4 from '../../assets/images/banner4.jpg'
import banner5 from '../../assets/images/banner5.jpg'
import banner6 from '../../assets/images/banner6.jpg'
import banner7 from '../../assets/images/banner7.jpg'

const images = [
    {
        id: 1,
        src: `${banner1}`,
        alt: "Image 1",
    },
    {
        id: 2,
        src: `${banner2}`,
        alt: "Image 2 ",
    },
    {
        id: 3,
        src: `${banner3}`,
        alt: "Image 3",
    },
    {
        id: 4,
        src: `${banner4}`,
        alt: "Image 4",
    },
    {
        id: 5,
        src: `${banner5}`,
        alt: "Image 5",
    },
    {
        id: 6,
        src: `${banner6}`,
        alt: "Image 6",
    },
    {
        id: 7,
        src: `${banner7}`,
        alt: "Image 7",
    },
];
export default images;